/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Greeting_BodyInputs */



/**
* | output |
* | --- |
* | "Your oneAI assistant. Ask me anything or let me help you get things done." |
*
* @param {Uno_Greeting_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_greeting_body = /** @type {((inputs?: Uno_Greeting_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Greeting_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein oneAI-Assistent. Frag mich alles oder lass mich dir helfen, Dinge zu erledigen.")
	return /** @type {LocalizedString} */ ("Your oneAI assistant. Ask me anything or let me help you get things done.")
});